import React from 'react';
import i18n from '../../i18n';
import borders from '@material-ui/system';
import Button from "@material-ui/core/Button/Button";
import Icon from "@material-ui/core/Icon/Icon";
import Grid from "@material-ui/core/Grid/Grid";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import Typography from "@material-ui/core/Typography/Typography";
import {FormattedDate} from "react-intl";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Divider from "@material-ui/core/Divider/Divider";
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import Paper from "@material-ui/core/Paper/Paper";
import {withStyles} from "@material-ui/core/styles/index";
import Chip from "@material-ui/core/Chip/Chip";
import FormLabel from "@material-ui/core/FormLabel/FormLabel";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import Link from "@material-ui/core/Link/Link";
import Date from "../Formater/Date";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';

class ContractDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showTab: 0
        };
    }

    render() {
        const {contract, classes} = this.props;

        return (
            <Grid container spacing={16}>
                <Grid item xs={6}>
                    <Card>
                        <CardContent>
                            <Grid container spacing={8}>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('contracts.person_name')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {contract.lecturer.first_name + ' ' + contract.lecturer.last_name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('contracts.course_name')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {contract.course.name}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('contracts.day_contract')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    {contract.day_contract &&
                                    <Typography>
                                        <Date value={contract.day_contract}/>
                                    </Typography>
                                    }
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('contracts.day_contract_start')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    {contract.day_contract_start &&
                                    <Typography>
                                        <Date value={contract.day_contract_start}/>
                                    </Typography>
                                    }
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('contracts.day_contract_end')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    {contract.day_contract_end &&
                                    <Typography>
                                        <Date value={contract.day_contract_end}/>
                                    </Typography>
                                    }
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('contracts.lessons')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {contract.lessons}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('contracts.payment')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {contract.payment + '€'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography>
                                        {i18n.get('contracts.qualification')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7}>
                                    <Typography>
                                        {contract.qualification}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        )
    }
}

const styles = {
    contractCard: {
        width: '500px',
        margin: 'auto',
    },
    gridDivider: {
        marginTop: '10px',
        marginBottom: '10px',
    },
    linkBoard: {
        backgroundColor: 'grey',
    },
    chipQuali: {
        margin: '5px',
    }
};

export default withStyles(styles)(ContractDetails);


// WEBPACK FOOTER //
// ./resources/assets/js/components/Contracts/ContractDetails.js